const routes = [
  { path: '/80Mesh', component: 80Mesh },
   { path: '/2040Mesh', component: 2040Mesh}
];

<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/home-hero.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-heading title="GARNET 80 MESH" />

          <base-body>
            Granate Mesh 80 con más de 10 años de experiencia como suministradora de este producto para empresas que utilicen el corte por chorro de agua. Trabajamos con los mejores materiales y productos para asegurar un resultado óptimo de la mayor calidad.
          </base-body>

          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn    to="/80Mesh">
              Ver más
            </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">o</span>

            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              text
            to="/2040Mesh" 
            >
              Garnet 20/40
            </base-btn>
               <!-- <router-link to="/80Mesh">Go to Foo</router-link> -->
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
  }
</script>
